import React, { FC, ReactNode } from 'react'

import { Counter } from 'components/page/PhotoViewer/Counter/Counter'
import {
  CenterWrapper,
  Wrapper,
} from 'components/page/PhotoViewer/Panel/PanelTop/PanelTop.styled'
import { PhotoViewerCloseButton } from 'components/page/PhotoViewer/PhotoViewerCloseButton/PhotoViewerCloseButton'

export const PanelTopView: FC<{
  selectedPhotoIndex: number
  menuTooltip?: ReactNode
  onClosePhotoViewer: () => void
  totalPhotos?: number
}> = ({
  // Пока не зарефакторил
  selectedPhotoIndex,
  totalPhotos,
  menuTooltip,
  onClosePhotoViewer,
}) => {
  return (
    <Wrapper>
      <PhotoViewerCloseButton onClosePhotoViewer={onClosePhotoViewer} />
      <CenterWrapper>
        <Counter
          currentIndexPhoto={selectedPhotoIndex + 1}
          countsPhotosAll={totalPhotos!}
        />
      </CenterWrapper>
      {menuTooltip}
    </Wrapper>
  )
}
